import Plain from "../types/Plain";

class BaseError extends Error {
    data: Plain;

    constructor(message: string, data: Plain = {}, cause?: Error) {
        super(message)
        this.data = data
        if (cause) {
            if (cause.stack) {
                this.stack += `\nCaused by: ${cause.stack}${data ? `. Data = ${JSON.stringify(data)}` : ''}`
            } else {
                this.stack += `\nCaused by:\nDetails: ${JSON.stringify(cause)}${data ? `. Data = ${JSON.stringify(data)}` : ''}`
            }
        }
    }
}

export default BaseError